<template>
  <v-text-field
    ref="field"
    :model-value="displayValue"
    :label="label"
    :placeholder="placeholder"
    :prefix="prefix"
    :readonly="readonly"
    :disabled="disabled"
    :clearable="clearable"
    :rules="rules"
    :hint="computedHint"
    :variant="inputVariant"
    :color="color"
    type="text"
    inputmode="numeric"
    @update:model-value="onInput"
    @blur="onBlur"
    class="text-field-white v-input-white"
  />
</template>

<script>
export default {
  name: 'CurrencyInput',
  props: {
    modelValue: {
      type: [String, Number],
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    outlined: {
      type: Boolean,
      default: false,
    },
    variant: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: undefined,
    },
    rules: {
      type: Array,
      default: () => [],
    },
    properties: {
      type: Object,
      default: () => ({}),
    },
    options: {
      type: Object,
      default: () => ({}),
    },
    thousandSeparator: {
      type: Boolean,
      default: false,
    },
    prefix: {
      type: String,
      default: '',
    },
  },
  emits: ['update:modelValue'],
  computed: {
    computedHint() {
      return this.properties.hint
    },
    inputVariant() {
      if (this.variant) {
        return this.variant
      }
      return this.outlined ? 'outlined' : 'filled'
    },
    displayValue() {
      if (this.modelValue === null || this.modelValue === undefined) {
        return ''
      }
      const str = String(this.modelValue)
      if (!this.thousandSeparator || str === '') {
        return str
      }
      const [intPart, decPart] = str.split('.')
      const formattedInt = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      return decPart !== undefined ? `${formattedInt}.${decPart}` : formattedInt
    },
  },
  methods: {
    onInput(value) {
      // Strip commas (thousand separators) and any other non-numeric characters
      const sanitized = String(value ?? '').replace(/,/g, '').replace(/[^\d.]/g, '')
      this.$emit('update:modelValue', sanitized)
    },
    onBlur() {
      if (this.modelValue === '' || this.modelValue === null || this.modelValue === undefined) {
        return
      }

      const precision = Number.isInteger(this.options.precision) ? this.options.precision : 0
      // Strip any residual commas before parsing (e.g. if modelValue was set externally)
      const rawValue = String(this.modelValue).replace(/,/g, '')
      const numericValue = Number(rawValue)
      if (!Number.isFinite(numericValue)) {
        this.$emit('update:modelValue', '')
        return
      }

      this.$emit('update:modelValue', numericValue.toFixed(precision))
    },
  },
}
</script>
